var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllSports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10002_5254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9688 8.77661C15.1562 9.05786 14.3125 9.21411 13.4375 9.24536C13.75 5.96411 12.4688 2.87036 10.2188 0.745361C13.5625 1.71411 16 4.77661 16 8.40161C16 8.52661 15.9688 8.65161 15.9688 8.77661ZM15.8438 9.87036C15.6875 10.8704 15.3125 11.8079 14.7812 12.6204C11.75 14.1516 8 13.9641 5.03125 11.8704C5.78125 10.7454 6.78125 9.74536 8 8.99536C10.5 10.3391 13.3125 10.5891 15.8438 9.87036ZM8.46875 8.12036C8.40625 5.27661 7.1875 2.71411 5.3125 0.870361C6.125 0.589111 7.03125 0.401611 8 0.401611C8.0625 0.401611 8.15625 0.401611 8.21875 0.432861C11.0625 2.30786 12.7812 5.65161 12.4375 9.24536C11.0938 9.15161 9.75 8.80786 8.46875 8.12036ZM4.3125 1.30786C4.9375 1.90161 5.5 2.55786 5.96875 3.27661C2.96875 4.68286 0.9375 7.30786 0.21875 10.3079C0.0625 9.71411 0 9.05786 0 8.40161C0 5.33911 1.75 2.65161 4.3125 1.30786ZM6.46875 4.15161C7.09375 5.33911 7.4375 6.71411 7.46875 8.12036C5.0625 9.62036 3.4375 11.9329 2.8125 14.4954C2.0625 13.8704 1.40625 13.0891 0.9375 12.2141C1.15625 8.80786 3.1875 5.65161 6.46875 4.15161ZM8 16.4016C6.40625 16.4016 4.9375 15.9641 3.6875 15.1516C3.84375 14.3079 4.15625 13.4954 4.53125 12.7454C7.25 14.6204 10.5625 15.0579 13.5312 14.1829C12.0938 15.5579 10.125 16.4016 8 16.4016Z",
    fill: "black",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10002_5254",
    x: 0,
    y: 0.401611,
    width: 16,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10002_5254"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10002_5254",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllSports);
export default ForwardRef;